import { useQuery } from '@tanstack/react-query'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'
import { constructUrlWithParams } from '../helpers'

export interface ContinentLocation {
  ContinentName: string
  ContinentCode: string
}

export interface CountryLocation {
  ContinentName: string
  ContinentCode: string
  CountryName: string
  CountryCode: string
}

export function useGetContinentLocations({
  enabled = true,
}: { enabled?: boolean } = {}) {
  const fetch = useFetch<ContinentLocation[]>()

  return useQuery({
    queryKey: ['/portinfo/continents'],
    queryFn: () => fetch(`${apiBase()}/portinfo/continents`),
    enabled,
  })
}

export function useGetCountryLocations({
  countryName,
}: {
  countryName?: string
}) {
  const fetch = useFetch<CountryLocation[]>()
  const url = constructUrlWithParams('/portinfo/countries', { countryName })

  return useQuery({
    queryKey: ['/portinfo/countries', countryName],
    queryFn: () => fetch(`${apiBase()}${url}`),
    enabled: !!countryName && countryName.length >= 3,
  })
}
